import i18n from 'i18next'
import type { Category } from '@models/Survey'
import { APP_SLUG } from '@models/AppType'
import { slugLooksLikeEque26 } from '@utils/editionSlug'

/** Default Home/MainMenu subtitles when slug is EQUE26 but overlays not loaded yet. */
const EQUE26_FALLBACK: Record<string, string> = {
  fr: 'Élections Québec 2026',
  en: '2026 Quebec election',
  es: 'Elecciones Quebec 2026',
}

function langKey(lng?: string): string {
  return (lng || i18n.language || 'fr').toLowerCase().split('-')[0]
}

function overlaysOf(category?: Category | null): Record<string, Record<string, string>> | null {
  if (!category) return null
  return category.uiI18nOverrides ?? category.ui_i18n_overrides ?? null
}

/**
 * Prefer edition `ui_i18n_overrides` Home.subTitle (admin-editable), then EQUE26
 * slug fallback, then i18n bundle string.
 */
export function resolveHomeSubTitle(
  category: Category | null | undefined,
  bundleFallback: string,
  lng?: string,
): string {
  const lang = langKey(lng)
  const map = overlaysOf(category)
  const fromEdition = map?.[lang]?.['Home.subTitle']?.trim()
  if (fromEdition) return fromEdition

  const scope = (category?.scopeCode ?? category?.scope_code ?? '').toUpperCase()
  const key = (category?.key ?? '').toLowerCase()
  const slug = (category?.urlSlug ?? category?.url_slug ?? APP_SLUG ?? '').toLowerCase()
  if (scope === 'EQUE26' || slugLooksLikeEque26(slug) || key.includes('eque26') || key.includes('quebec-2026')) {
    return EQUE26_FALLBACK[lang] || EQUE26_FALLBACK.fr
  }

  return bundleFallback
}
